module.exports = __webpack_public_path__ + "static/media/Statua_050.d938a7a0.jpg";